module.exports = __webpack_public_path__ + "fonts/lato-bold-webfont.58d1cfce.woff";